<template>
  <el-card class="box-card form-screen mb-50 form-notice">
    <el-row>
      <el-col :span="24">
        <el-form :rules="rules" :model="form" ref="form" id="form" method="post" :action="urls.action">
          <el-form-item prop="title" :error="getErrorForField('title', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('notices.form.input_labels.title') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="title" v-model="form.title" :placeholder="$t('notices.form.input_placeholder.title')"></el-input>
          </el-form-item>
          <el-form-item  prop="content" :error="getErrorForField('content', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('notices.form.input_labels.content') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="content" v-model="form.content" :placeholder="$t('notices.form.input_placeholder.content')"
              type="textarea" class="textarea h-630">
            </el-input>
          </el-form-item>
          <input type="hidden" name="_token" :value="csrf">
          <input type="hidden" name="id" :value="notice.id" v-if="notice && notice.id">
          <el-form-item class="btn-container mt-30">
            <el-button type="primary" @click="submit('form')" class="btn btn-submit btn-w157">{{ btn }}</el-button>
            <el-button @click="back" class="btn btn-back btn-w157">{{ $t('back') }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
  export default {
    props: {
      errors: { type: Object, required: false, default: {} },
      input: { type: Object, required: false },
      notice: { type: Object, default: {} },
      urls: { type: Object, required: true, default: {} },
      btn: { type: String, required: true, default: '' },
    },
    data() {
      return {
        form: {
          title: '',
          content: '',
        },
        rules: {
          title: [
            { required: true, message: this.$t('errors.required', [this.$t('notices.form.input_labels.title')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('notices.form.input_labels.title'), 255]), trigger: 'blur' },
          ],
          content: [
            { required: true, message: this.$t('errors.required', [this.$t('notices.form.input_labels.content')]), trigger: 'blur' },
          ],
        },
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    },
    methods: {
      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            document.querySelector(".el-container").classList.add("disabled");
            document.querySelector("#loader").style.display = "block";
            const form = document.getElementById("form");
            form.submit();
          } else {
            return false;
          }
        });
      },
      isErrorForField(field, errors) {
        return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
      },
      getErrorForField(field, errors) {
        return this.isErrorForField(field, errors) ? errors[field][0] : '';
      },
      back() {
        window.location.href = this.urls.back;
      },
    },
    created() {
      const tempData = (Object.keys(this.input).length === 0) ? this.notice : this.input;
      this.form = Object.fromEntries(Object.entries(tempData).map(([key, value]) => [key, value]));
   },
  }
</script>
<style lang="scss">
  .form-notice {
    .el-card__body {
      padding-top: 0;
    }

    .el-form {
      .el-form-item {
        &:first-child {
          .el-form-item__content {
            margin-top: 0;
          }
        }
        .el-input {
          width: 660px;
            .el-input__inner {
              height: 61px;
            }
        }
      }

      .el-textarea {
        width: 660px;
        .el-textarea__inner {
          height: 630px;
          padding: 20px 30px;
          letter-spacing: 1.3px;
          line-height: 29px;
        }
      }

      .image {
        width: 800px;
        height: 600px;
        margin-top: 20px;
      }

      .btn-upload {
        margin-left: 0px;
      }
    }

    .el-form-item__content {
      text-align: left !important;
      margin-top: 25px;
      .el-button + .el-button {
        margin-left: 25px;
      }
    }
  }
</style>
